import { ref, watchEffect } from "@vue/composition-api";
export var PAGE_TOGGLER_TARGET;
(function (PAGE_TOGGLER_TARGET) {
  PAGE_TOGGLER_TARGET["INFORMATION"] = "information";
  PAGE_TOGGLER_TARGET["SUMMARY"] = "summary";
})(PAGE_TOGGLER_TARGET || (PAGE_TOGGLER_TARGET = {}));
export const usePageTogglers = () => {
  const togglerMetadata = ref({
    applicantIndex: null,
    incomeIndex: null,
    assetIndex: null
  });
  const showInformationPage = ref(false);
  watchEffect(() => {
    if (!showInformationPage.value) {
      togglerMetadata.value = {
        applicantIndex: null,
        incomeIndex: null,
        assetIndex: null
      };
    }
  });
  const handlePageTogglerNavigation = event => {
    const {
      target,
      metadata
    } = event;
    if (metadata) {
      togglerMetadata.value = metadata;
    }
    if (target === PAGE_TOGGLER_TARGET.INFORMATION) {
      showInformationPage.value = true;
    }
    if (target === PAGE_TOGGLER_TARGET.SUMMARY) {
      showInformationPage.value = false;
    }
  };
  const handleNavigateNext = () => {
    if (!showInformationPage.value) return;
    return () => {
      handlePageTogglerNavigation({
        target: PAGE_TOGGLER_TARGET.SUMMARY
      });
    };
  };
  const handleNavigateBack = () => {
    if (!showInformationPage.value) return;
    return () => {
      handlePageTogglerNavigation({
        target: PAGE_TOGGLER_TARGET.SUMMARY
      });
    };
  };
  const navigateToInformationPage = metadata => {
    handlePageTogglerNavigation({
      target: PAGE_TOGGLER_TARGET.INFORMATION,
      metadata
    });
  };
  return {
    handlePageTogglerNavigation,
    showInformationPage,
    togglerMetadata,
    handleNavigateNext,
    handleNavigateBack,
    navigateToInformationPage
  };
};